import ENV from "config/Env";
import { permanentBackendQueryKey } from "hooks/useTypedQuery";

import type { DBBLeaseCompanySummary, DBBStorageLocationSummary } from "models";

const component = "DBBCreateContractModal";

export const DBBCreateContractModalQueryKeys = {
  leaseCompanies: (dealer_location_id?: number) =>
    permanentBackendQueryKey<DBBLeaseCompanySummary[]>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/dbb/lease_companies", params: { dealer_location_id } }),
  storageLocations: (dealer_location_id?: number) =>
    permanentBackendQueryKey<DBBStorageLocationSummary[]>({
      component,
      baseUrl: ENV.appointmentBaseURL,
      endpoint: "/dbb/storage_locations",
      params: { dealer_location_id }
    })
};
